import {Tools} from "../../website/lib/app/tools";

export const tagName = (value) =>
{
    return function decorator(target)
    {
        target.prototype.tagName = value;
    }
};

export const model = (value) =>
{
    return function decorator(target)
    {
        target.prototype.model = value;
    }
};

export const url = (value) =>
{
    return function decorator(target)
    {
        target.prototype.url = value;
    }
};

/**
 * @param value {Object} - object of shape {eventName1: methodName1, eventName2: methodName2...}
 * @param clearPreviousEvents {boolean} - remove previous events and keep only those. Default: false
 * @return {decorator}
 */
export const events = (value, { clearPreviousEvents = false } = {}) =>
{
    return function decorator(target)
    {
        if (clearPreviousEvents)
        {
            target.prototype.events = value;
        }
        else
        {
            target.prototype.events = Object.assign({}, target.prototype.events, value);
        }
    }
};

export const className = (value) =>
{
    return function decorator(target)
    {
        target.prototype.className = value;
    }
};

export const el = (value) =>
{
    return function decorator(target)
    {
        target.prototype.el = value;
    }
};

export const template = (value) =>
{
    return function decorator(target)
    {
        const template = Tools.makeTemplate(value);
        if (!target.prototype.template){
            Object.defineProperties(target.prototype, {
                template: {
                    value : template,
                    enumerable : true,
                    configurable: true,
                }
            });
        }
        else {
            if (!_.isPlainObject(value)){
                console.error(`${target.prototype.constructor.name} a déjà un template venant du père, il faut passer un objet pour merger`, target.prototype.template, value);
            }
            else {
                Object.defineProperties(target.prototype, {
                    template: {
                        value : Tools.makeReadonlyObject(Object.assign(template, target.prototype.template)),
                        enumerable : true,
                        configurable: true,
                    }
                });
            }
        }

    }
};

export const defaults = (value) =>
{
    return function decorator(target)
    {
        target.prototype.defaults = _.extend({}, target.prototype.defaults || {}, value) ;
    }
};

export const props = (value) =>
{
    return function decorator(target)
    {
        //on utilise les properties pour les mettre en readonly
        const descriptor = Tools.makeDescriptor(value, false);
        //console.log(`${target.prototype.constructor.name}:props`,value, descriptor);
        Object.defineProperties(target.prototype, descriptor);
        //Object.assign(target.prototype, value);
    }
};


export const confProps = (value) =>
{
    return function decorator(target)
    {
        //on utilise les properties pour les mettre en readonly
        const descriptor = Tools.makeDescriptor(value, true);
        //console.log(`${target.prototype.constructor.name}:confProps`, value, descriptor);
        Object.defineProperties(target.prototype, descriptor);
        //Object.assign(target.prototype, value);
    }
};
